import InfoCardBlock from 'components/common/form/custom/ReplicatedInfo/InfoCardBlock';
import { WebFormCustomFields } from 'store/ui-stores/web-form/webFormStore';
import { DDARAdditionalContact, ReplicatedCustomInfo } from 'types/formService';
import { DefaultFormFields, FormController, FormControl } from '@insurancemenu/imenu-components-lib/dist/utils/forms';
import { createStyles } from 'components/common/form/custom/ReplicatedInfo/InfoCardModal/styles';
import { InputText, Select } from '@insurancemenu/imenu-components-lib';
import React from 'react';

const asAdditionalContact = (info: ReplicatedCustomInfo): DDARAdditionalContact => info as DDARAdditionalContact;

export const getAdditionalContacts = (): JSX.Element => {
  return (
    <InfoCardBlock
      key="additionalContacts"
      componentName="additionalContacts"
      amountOfAdditionalCards={4}
      customModalHeaderName="Contact"
      addButtonName="Add Additional Contact"
      getCustomComponentField={(customField: WebFormCustomFields) => {
        return customField.ddarAdditionalContacts;
      }}
      columns={[
        { title: 'Type', width: '13rem', getValue: (info) => asAdditionalContact(info).type ?? '' },
        { title: 'Name', width: '17rem', getValue: (info) => asAdditionalContact(info).name ?? '' },
        { title: 'Email', width: '17rem', getValue: (info) => asAdditionalContact(info).email ?? '' },
      ]}
      createCustomForm={(): FormController<DefaultFormFields> => {
        return new FormController<DefaultFormFields>({
          type: new FormControl<string>('', { validations: [], trim: true }),
          name: new FormControl<string>('', { validations: ['validName'], trim: true }),
          email: new FormControl<string>('', { validations: ['isEmailValid'], trim: true }),
        });
      }}
      customModalContent={(customForm: FormController<DefaultFormFields>): JSX.Element => {
        const classes = createStyles();
        const type = customForm.fields.type;
        const name = customForm.fields.name;
        const email = customForm.fields.email;

        return (
          <>
            <Select
              label="Exempt according to above requirement?"
              name="type"
              value={type.value?.toString()}
              options={[
                { value: 'Broker Additional', label: 'Broker Additional' },
                { value: 'Company Additional', label: 'Company Additional' },
              ]}
              onChange={customForm.onFieldChange}
              validationMessage={type.unpassedValidationMsg || ''}
              validationPassed={!type.unpassedValidationMsg}
              className={classes.regularField}
            />
            <InputText
              label="Name"
              name="name"
              maxLength={50}
              value={name.value?.toString()}
              onChange={customForm.onFieldChange}
              validationMessage={name.unpassedValidationMsg || ''}
              validationPassed={!name.unpassedValidationMsg}
              className={classes.regularField}
            />
            <InputText
              label="Email"
              name="email"
              maxLength={50}
              value={email.value?.toString()}
              onChange={customForm.onFieldChange}
              validationMessage={email.unpassedValidationMsg || ''}
              validationPassed={!email.unpassedValidationMsg}
              className={classes.fullWidth}
            />
          </>
        );
      }}
    />
  );
};
